<template>
  <div class="main">
    <ball></ball>
    <div class="nav">
      <!-- <Nav :title="'预约挂号记录'" :fixed="true"></Nav>
      <div class="top"></div> -->
         <div class="nav">
      <van-nav-bar
        title="挂号记录"
        left-arrow
        :fixed=flexfalg
         left-text="返回"
        @click-left="onClickLeft"
      />
      <div class="top"></div>
       </div>
    </div>
      <van-notice-bar
  left-icon="info-o"
  color="#1989fa"
  background="#ecf9ff"
  :scrollable="true"
  :text=this.tips
/>
    <div class="cholseDate">
      <div class="dateitem" :value="begindate"  @click="showCalendar['begindate'] = true">{{begindate}}</div>
      <div class="dateitem_-">~</div>
      <div class="dateitem" :value="enddate" @click="showCalendar['enddate'] = true">{{enddate}}</div>
      <van-calendar color="#5b8df6" :min-date="minDate" 
      :max-date="maxDate" v-model="showCalendar['begindate']" @confirm="(value) =>onConfirm(value,'begindate')" />
      <van-calendar color="#5b8df6" :min-date="minDate" 
      :max-date="maxDate" v-model="showCalendar['enddate']" @confirm="(value) => onConfirm(value,'enddate')" />
    </div>
    
    <div v-if="showempty" class="empty">
      <van-empty image="https://account.kmmds.top/datainfo_pic/error.png"  description="暂无预约挂号记录" />
    </div>
    <div v-else>
      <div class="paycard" v-for="(item, index) in cardList" :key="index">
        <div class="head">
          <div>预约记录</div>
          <div>{{ item.PatientName }}</div>
        </div>
        <div claass="content">
          <!-- <div class="Crow">
            <div>支付方式:{{ item.PayTypeName  }}</div>
          </div> -->

          <div class="Crow">
            <div>挂号科室名称：{{ item.DepartmentName }}</div>
          </div>
          <div class="Crow">
            <div>就诊序号:</div>
            <div >{{ item.SeeNo }}</div>
          </div>
            <div class="Crow">
            <div>预约时间：{{ item.SeeTime }}</div>
          </div>
          <div class="Crow">
            <div>创建时间：{{ item.RegTime }}</div>
          </div>
          <div class="Crow">
            <div>挂号类型：{{ item.FeeType }}</div>
          </div>
          <div class="Crow">
            <div>挂号费</div>
            <div class="red">￥{{ item.TotalCost }}</div>
          </div>
          
           <div class="Crow" v-if="isCancel">
            <div></div>
            <div><van-button  size="small" color="#5B8DF6" @click="refund(item)">取消挂号</van-button></div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Nav from "../../components/nav.vue";
import { Dialog } from "vant";
import backindex from '@/mixins/backindex'
import setOptions from "@/mixins/setOption";
export default {
    mixins: [backindex,setOptions],
  data() {
    return {
      isCancel:false,
      showCalendar:{
      begindate:false,
      enddate:false,
      }, 
      show:false,
      begindate: new Date(),
      enddate:new Date(),
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(),
      flexfalg:true,
      vtypeflag:true,
      registerhistoryLIst: [],
      medCardNo: null,
      cardList: [],
      showcard: false,
      showempty: false,
      version:"",
      validtext:"",
      tips:"",
    };
  },
  components: {
    Nav,
  },
  mounted() {
    this.getregisterCancel()
    this.getyDay(this.maxDate)
    this.enddate= this.getyDay(this.enddate)
    this.begindate=this.getLmDay(this.begindate)
    if (this.$route.query) {
      this.medCardNo = this.$route.query.clientId;
      // console.log(this.medCardNo)
    }
    if (!this.medCardNo || this.medCardNo == "") {
      // console.log(this.medCardNo);
       this.goconfUser();
      // this.Dialog();
    }
    this.getmedicalcard();
    this.getTips();
  },
  // 过滤器
  filters: {
    FinalPrice(regFee) {
      return regFee.toFixed(2);
    },
     Validtext(validFlag){
       if(validFlag==1){
         return "已缴费"
       }else if(validFlag==0){
         return "已退费"
       }else if(validFlag==2){
        return "订单作废"
       }
     }
  },
  methods: {
    async getregisterCancel() {
      try {
        this.$showLoad();
        let url = "/register/isrefundfee";
        let data = {};
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          data,
          (resultData) => {
            this.$hideLoad();
            this.IsRefundfeetodaynow = resultData.data.IsRefundfeetodaynow;
            if (resultData.data.IsRefundfee == "0") {
              this.isCancel = false;
            } else if (resultData.data.IsRefundfee == "1") {
              this.isCancel = true;
            }
          }
        );
      } catch (error) {}
    },
     async getTips() {
      try {
        this.$showLoad();
        let url = "/hospitalconf/queryTips";
        await this.$axios_request.request_data(
          "nodeserver",
          url,
          "POST",
          null,
          (data) => {
             this.$hideLoad()
         this.tips=data.data.registerhistory
        
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
    //退费
    async cancelREg (item){
      
    try {
      this.$showLoad();
      if (new Date(item.SeeTime).toString().slice(0, 10) !== new Date().toString().slice(0, 10)) {
					this.$toast.fail('当天以为不可线上退号')
					return
				}
      let url = "/register/DhishisRefunfee";
      let R_date ={
        PatientID:item.PatientID,
        DepartmentID:item.DepartmentID,
        DoctorID:item.DoctorID,
        RegDate:item.SeeTime,
        Amount:item.TotalCost,
        sPayTransNo:""
      }
      await this.$axios_request.axios_request_body(
        "nodeserver",
        url,
        "POST",
        R_date,
        (data) => {
          if(data.code==-1){
            this.$toast.fail(data.data.data.statusText)
          }else if(data.code==-2){
            this.$toast.fail('该订单以退费')
          }
          else{
            this.$toast.success('取消挂号成功')
          }
        }
      );
    } catch (error) {
      console.log(error);
      this.$hideLoad();
    }
  },
     getyDay(date){
         date.setTime(date.getTime()+24*60*60*1000*7);
        date = date.getFullYear()+"-" + (date.getMonth()+1) + "-" + date.getDate();
         return date
    },
    //获取上个月
    getLmDay(date){
         date.setTime(date.getTime()-24*60*60*1000*30);
        date = date.getFullYear()+"-" + (date.getMonth()+1) + "-" + date.getDate();
         return date
    },
    //格式化日期
    formatDate(date) {
      return `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
    },
    //选择日期
     onConfirm(value,type) {
      //  console.log(new Date(value))
       console.log( type)
      this[type] = this.formatDate(new Date(value));
      this.showCalendar[type]= false;
      this.getmedicalcard()
    },
     onClickLeft(){
      this.$router.push('/index');
    },
    Dialog() {
      // console.log(123)
      this.$dialog
        .confirm({
          message: "请选择就诊人信息",
        })
        .then(() => {
          this.goconfUser();
        })
        .catch(() => {
          // on cancel
          this.$router.push("/index");
        });
    },
    async getmedicalcard() {
      // console.log(this.medCardNo)
      try {
        // this.$showLoad();
        // this.isLoad = true
        let url = "/register/registerRecord";
        let medCardNo = {
           medCardNo: this.medCardNo,
           start_date:this.begindate,
           end_date:this.enddate
        };
        // console.log(medCardNo);
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          medCardNo,
          (data) => {
            console.log(data.data)
              this.cardList = data.data;
              if(data.data.length==0 ){
                this.showempty=true
              }else{
                this.showempty=false
              }
          }
        );
      } catch (error) {}
    },
    //go选择用户
    goconfUser() {
      this.$router.push("/patient_card_selectuser");
    },

    // 退费
    refund(item) {
      Dialog.confirm({
        message: "您确定要取消挂号吗",
      })
        .then(() => {
         this.cancelREg(item)
        })
        .catch(() => {
          // on cancel
        });
    },
     async getPayWay(){
    try {
      this.$showLoad();
      let url = "/hospitalconf/index/getPayType";
      await this.$axios_request.axios_request_body(
        "nodeserver",
        url,
        "POST",
        null,
        (data) => {
          this.$hideLoad();
          this.version=data.data.version
          let type= data.data.version
          if(type=="D"){
            this.vtypeflag=false
          }else{
            this.vtypeflag=true
          }
          console.log(data)
        }
      );
    } catch (error) {
      console.log(error);
      this.$hideLoad();
    }
  },
  },
};
</script>

<style lang="scss" scoped>
.red {
  color: red;
}
.main {
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  .top {
    height: 50px;
  }
  .cholseDate{
    display: flex;
    margin: 0px auto;
     margin-top: 10px;
    .dateitem_-{
      margin-left: 20px;
       color:#95a5a6 ;
    }
    .dateitem{
      margin-left: 20px;
      color:#95a5a6 ;
      border-bottom: 1px solid #95a5a6  ;
    }
  }
  .paycard {
    background-color: #fafafa;
    padding: 5px;
    width: 93%;
    display: flex;
    flex-direction: column;
    // border: 1px solid #5b8df6;
    border-radius: 8px;
    margin: 0px auto;
    margin-top: 8px;
    margin-bottom: 8px;
    // box-shadow: 0 8px 12px #6666;
     box-shadow: 0 1px 3px #5b8df6;
  }
  .head {
    margin-top: 5px;
    margin-left: 10px;
    margin-right: 10px;
    color: #5b8df6;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dashed #5b8df6;
    font-size: 16px;
    line-height: 30px;
  }
  .content {
    width: 90%;

    display: flex;
    flex-direction: column;
    border: 1px solid #95a5a6;
    border-radius: 15px;
    margin: 5px auto;
  }
  .Crow {
    color: #747d8c;
    margin-left: 20px;
    margin-right: 20px;
    line-height: 30px;
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    .gold {
      color: #e74c3c;
    }
    .green {
      color: #2ed573;
    }
  }
  .line {
    border-bottom: 1px solid #95a5a6;
  }
}
// 退费
// .refund_btn {
//   background-color: #5b8df6;
//   width: 70px;
//   margin-right: -5px;
//   height: 30px;
//   line-height: 30px;
//   border-radius: 5px;
//   color: #ffffff;
//   letter-spacing: 3px;
//   border: 0px;
// }
</style>